import React, { useEffect, useState } from 'react';
import './Dashboard.css';
import SideBar from '../SideBar/SideBar';
import appointmentService from '../../services/appointment.service';

interface TodayAppointment {
    id: number;
    time: string;
    customer: string;
    service: string;
    staff: string;
    status: 'PENDING' | 'CONFIRMED' | 'COMPLETED' | 'CANCELLED' | 'BLOCKED' | string;
    cost: number;
}

const Dashboard: React.FC = () => {
      

    const [todaysAppointments, setTodaysAppointments] = useState<TodayAppointment[]>([]);
    const [loadingAppointments, setLoadingAppointments] = useState(true);
    const [errorAppointments, setErrorAppointments] = useState<string | null>(null);

    useEffect(() => {
        setLoadingAppointments(true);
        appointmentService.getTodaysAppointments()
            .then((data: any[]) => {
                const mapped: TodayAppointment[] = (data || []).map((appt: any) => {
                    const firstName = (appt.firstName || '').trim();
                    const lastName = (appt.lastName || '').trim();
                    const customer = `${firstName} ${lastName}`.trim() || '-';
                    const time = (appt.time || '').slice(0, 5);

                    return {
                        id: Number(appt.id),
                        time,
                        customer,
                        service: appt.serviceName || '-',
                        staff: '-',
                        status: appt.status || 'PENDING',
                        cost: Number(appt.price || 0)
                    };
                });
                setTodaysAppointments(mapped);
                setErrorAppointments(null);
            })
            .catch(() => {
                setErrorAppointments('Αποτυχία φόρτωσης ραντεβού.');
            })
            .finally(() => setLoadingAppointments(false));
    }, []);

    return (
        <div className="admin-container">
            <SideBar />
            <div className="admin-content">
                <div className="dashboard-header">
                    <h2>Επισκόπηση & Νέα</h2>
                    <span className="date-display">{new Date().toLocaleDateString('el-GR', { weekday: 'long', day: 'numeric', month: 'long' })}</span>
                </div>

                {/* Stats Row */}
                <div className="dashboard-cards">
                    <div className="card stat-card blue">
                        <div className="stat-icon">📅</div>
                        <div className="stat-info">
                            <h3>Ραντεβού Σήμερα</h3>
                            <p> {todaysAppointments.length}</p>
                        </div>
                    </div>
                    <div className="card stat-card green">
                        <div className="stat-icon">💰</div>
                        <div className="stat-info">
                            <h3>Τζίρος Ημέρας</h3>
                            <p>{todaysAppointments.reduce((total, appt) => appt.status === 'CANCELLED' ? total : total + (appt.cost || 0), 0)}€</p>
                        </div>
                    </div>
                    {/* <div className="card stat-card purple">
                        <div className="stat-icon">👥</div>
                        <div className="stat-info">
                            <h3>Νέοι Πελάτες (Εβδ.)</h3>
                            <p>8</p>
                        </div>
                    </div> */}
                    {/* <div className="card stat-card orange">
                        <div className="stat-icon">⭐</div>
                        <div className="stat-info">
                            <h3>Μ.Ο. Αξιολογήσεων</h3>
                            <p>4.9</p>
                        </div>
                    </div> */}
                </div>

                <div className="dashboard-grid">
                    {/* Appointments Today Section */}
                    <div className="dashboard-main-col">
                        <div className="dashboard-section appointments-today">
                            <div className="section-header">
                                <h3>✂️ Σημερινό Πρόγραμμα (Live)</h3>
                                <button className="view-all-btn">Διαχείριση</button>
                            </div>
                            <div className="appointments-list-table">
                                <div className="appt-table-header">
                                    <span>Ώρα</span>
                                    <span>Πελάτης</span>
                                    <span>Υπηρεσία</span>
                                    <span>Barber</span>
                                    <span>Status</span>
                                </div>
                                {loadingAppointments ? (
                                    <div className="appt-table-row"><span>Φόρτωση...</span></div>
                                ) : errorAppointments ? (
                                    <div className="appt-table-row"><span>{errorAppointments}</span></div>
                                ) : todaysAppointments.length === 0 ? (
                                    <div className="appt-table-row"><span>Δεν υπάρχουν ραντεβού για σήμερα.</span></div>
                                ) : (
                                    todaysAppointments.map(appt => (
                                        <div key={appt.id} className="appt-table-row">
                                            <span className="appt-time">{appt.time}</span>
                                            <div className="appt-customer">
                                                <span>{appt.customer}</span>
                                            </div>
                                            <span className="appt-service">{appt.service}</span>
                                            <span className="appt-staff">{appt.staff}</span>
                                            <span className={`appt-status ${appt.status?.toLowerCase()}`}>
                                                {appt.status === 'COMPLETED' ? 'Ολοκληρώθηκε' :
                                                    appt.status === 'CONFIRMED' ? 'Επιβεβαιωμένο' :
                                                        appt.status === 'PENDING' ? 'Εκκρεμεί' :
                                                            appt.status === 'CANCELLED' ? 'Ακυρώθηκε' :
                                                                appt.status === 'BLOCKED' ? 'Μη διαθέσιμο' : appt.status}
                                            </span>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>


                    </div>

                    {/* Quick Actions & Reviews Side */}
                    <div className="dashboard-sidebar">
                        <div className="dashboard-section quick-actions">
                            <h3>⚡ Γρήγορες Ενέργειες</h3>
                            <div className="action-buttons">
                                {/* <button>+ Νέο Ραντεβού</button>
                                <button>+ Νέος Πελάτης</button>
                                <button>📢 Αποστολή SMS</button> */}
                            </div>
                        </div>

                        <div className="dashboard-section reviews-widget">
                            <h3>💬 Πρόσφατες Κριτικές</h3>
                            <div className="reviews-list">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;

